// extracted by mini-css-extract-plugin
export default {"container":"aq-z","brandName":"bq-z","productName":"cq-z","productNamePdpEnhancements":"dq-z","breakLongProductName":"eq-z"};